/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid200,
  DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid400,
  DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid401,
  DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid404,
  DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid500,
  DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest,
  DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationResponse,
  DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParams,
} from "../../types/classPlanningGradeAndFrequenceConfigurationController/DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid.ts";
import { classroomDisciplineIdsViewModelSchema } from "../classroomDisciplineIdsViewModelSchema.ts";

export const deleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParamsSchema =
  z.object({
    classModuleId: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid200Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const deleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid400Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid401Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid404Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid500Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid500>;

export const deleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequestSchema =
  z.lazy(
    () => classroomDisciplineIdsViewModelSchema,
  ) as unknown as ToZod<DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest>;

export const deleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationResponseSchema =
  z.lazy(
    () =>
      deleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid200Schema,
  ) as unknown as ToZod<DeleteApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationResponse>;
